/**
 * qualifierCard.tsx
 * 
 * @copyright jnakaso.com
 * 
 *  home page
 * 
 */
import { Card, Center, Stack, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { storageService } from "src/services/storageService";

export function QualiferStack(props: { season: number }) {
    const [qualifiers, setQualifiers] = useState<any>([]);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (props.season) {
            storageService.getSeasonFile(props.season, 'qualifiers.json')
                .then(t => setQualifiers(JSON.parse(t)))
                .catch(err => console.log(err));
        }
    }, [props])

    useEffect(() => {
        if (qualifiers) {
            setRows(qualifiers.map((s: any) =>
                <Card key={s.player}>
                    <Text fw={600} >{s.player}</Text>
                    <div>{s.date} {s.course} #{s.hole}</div>
                </Card >
            ))
        }
    }, [qualifiers])
    return <Stack>
        {(rows.length > 0) && rows}
        {(rows.length === 0) && <Center>No one yet!</Center>}
    </Stack >
}

export function QualifierCard(props: { season: number, qualifiers: any }) {
    return <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Card.Section>
            <Center h={80} bg="var(--mantine-color-gray-light)">
                <Text fw={800} >{props.season} KP Qualifiers</Text>
            </Center>
        </Card.Section>
        <QualiferStack season={props.season} />
    </Card>
}

export default QualifierCard;